<template>
  <main>
    <div class="container">
      <div class="preloader" v-if="addPreloader">
        <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
      </div>
      <div class="main-wrapper">
          <form class="order-list" @submit.prevent="sendForm()">
            <h1 class="main-title">ваш заказ</h1>
            <div class="order-items" v-if="!isCartEmpty">
                <CartItem 
                    @delCartItem="removeCartItem($event)"
                    v-for="(product, index) in localCart" 
                    :key="index"
                    :product="product">
                </CartItem>
            </div>
            <div class="order-items" v-else style="margin-bottom: 30px;">
                Товаров в корзине нет!
            </div>
            <a :href="collectionUrl" class="backToCatalog">Вернуться в каталог</a>
            <input id="send-form" type="submit" :value="buttonText">
        </form>
      </div>
    </div>
  </main>
</template>
<script>
import CartItem from "@/components/cart/cartItem";
export default {
  components: { CartItem },
  data: () => ({
      localCart: {},
      collectionUrl: '',
      buttonText: "Заказать",
      addPreloader: false
  }),
  methods: {
      removeCartItem(e){
        this.$delete(this.localCart, e)
        this.$localStorageSet('miniCart', this.localCart)
      },
      sendForm(){
        if(!this.isCartEmpty){
          this.addPreloader = true
          this.$store.dispatch('CREATE_ORDER_SHOP', this.$route.params.shopName).then(r =>{
            this.$makeToast(
              "Поздравляем!",
              "success",
              `Заказ успешно сформирован! 
              ID заказа = ${r.data.data.orderId}`
            );
            this.$localStorageSet('miniCart', {});
            setTimeout(()=>{this.$router.push('/shop-pre-catatlog')}, 3000)
          })
        } 
      }
  },
  created(){
      this.localCart = this.$localStorageGet('miniCart');
      this.collectionUrl ='/shop-pre-catatlog'; //Url текущей коллекции
  },
  computed: {
      isCartEmpty(){  //Проверить пустая корзина или нет
          if(Object.keys(this.localCart).length == 0){
            this.buttonText ="Выйти из магазина"
          }else{
            this.buttonText ="Заказать"
          }

          return Object.keys(this.localCart).length == 0 ? true : false
      }
  },
  watch: {
      localCart: {
        handler(val){
            this.$localStorageSet('miniCart', val)
        },
        deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
  #send-form{
    font-size: 16px;
  }
</style>